import React, { useState } from 'react';
import { Box, Button, VStack, Text, Alert, AlertIcon } from '@chakra-ui/react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../lib/firebase';

const TestAuth: React.FC = () => {
  const [email, setEmail] = useState('test@example.com');
  const [password, setPassword] = useState('password123');
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testEmailAuth = async () => {
    setLoading(true);
    setResult('');
    
    try {
      // Try to create a test user first
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      setResult(`✅ Email auth successful! User: ${userCredential.user.email}`);
    } catch (error: any) {
      if (error.code === 'auth/email-already-in-use') {
        // Try to sign in instead
        try {
          const userCredential = await signInWithEmailAndPassword(auth, email, password);
          setResult(`✅ Email sign-in successful! User: ${userCredential.user.email}`);
        } catch (signInError: any) {
          setResult(`❌ Sign-in failed: ${signInError.message}`);
        }
      } else {
        setResult(`❌ Auth failed: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={8} maxW="600px" mx="auto">
      <VStack spacing={4} align="stretch">
        <Text fontSize="2xl" fontWeight="bold">Firebase Auth Test</Text>
        
        <Alert status="info">
          <AlertIcon />
          Testing email/password authentication to bypass QUIC issues
        </Alert>

        <Box>
          <Text mb={2}>Email:</Text>
          <input 
            type="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
          />
        </Box>

        <Box>
          <Text mb={2}>Password:</Text>
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
          />
        </Box>

        <Button 
          onClick={testEmailAuth} 
          isLoading={loading}
          colorScheme="blue"
          size="lg"
        >
          Test Email Authentication
        </Button>

        {result && (
          <Box p={4} bg="gray.100" borderRadius="md">
            <Text whiteSpace="pre-wrap">{result}</Text>
          </Box>
        )}

        <Text fontSize="sm" color="gray.600">
          This test bypasses Google OAuth and tests Firebase Auth directly with email/password.
          If this works, the issue is specifically with Google OAuth and QUIC protocol.
        </Text>
      </VStack>
    </Box>
  );
};

export default TestAuth;
